const Immutable = require('immutable')
const { keyedReviver } = require('client-v2/common/state/revivers')

class AuthModalRecord extends Immutable.Record({
  errorProvider: String(),
  errorType: String(),
  hasAccount: Boolean()
}) {
  // No methods
}

AuthModalRecord.reviver = keyedReviver(AuthModalRecord, {
  // No nested data structures
})

module.exports = AuthModalRecord
